import DevslabComponent from './core/DevslabComponent'
import DevslabBlock from './core/DevslabBlock'

import 'lazysizes'

import { buttonGrid } from '@helper/buttonGrid'
import { lazyLoading } from '@core/lazyloading'
import { handleImageSizes } from '@core/images'
import { mainHeader } from '@helper/mainHeader'
import readmore from '@core/readmore'
import { floatingFormLabels } from '@helper/floatingFormLabels'
import { backToTop } from '@helper/backToTop'

window.customElements.define('devslab-component', DevslabComponent)
window.customElements.define('devslab-block', DevslabBlock)

window.addEventListener('load', () => {
  try {
    mainHeader()
  } catch (error) {
    console.error('Error initializing main header:', error)
  }

  floatingFormLabels()
  buttonGrid()
  lazyLoading()
  readmore()
  handleImageSizes(
    Array.from(document.querySelectorAll('img[data-sizes="auto"]'))
  )
  backToTop()
})
